import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Variant-reactive sale campaign date display.
 */
class SaleDate extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `sale-date[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newElement) return;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('sale-date')) {
  customElements.define('sale-date', SaleDate);
}
